var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_238_1737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_238_1737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.78333 10.5194L7.09722 8.16667L9.43056 10.5194L10.3444 9.58611L8.03056 7.23333L10.3444 4.88056L9.43056 3.94722L7.09722 6.3L4.78333 3.94722L3.85 4.88056L6.18333 7.23333L3.85 9.58611L4.78333 10.5194ZM2.83889 14C2.52778 14 2.25556 13.8833 2.02222 13.65C1.78889 13.4167 1.67222 13.1444 1.67222 12.8333V1.75H0.875V0.583333H4.53056V0H9.66389V0.583333H13.3194V1.75H12.5222V12.8333C12.5222 13.1444 12.4056 13.4167 12.1722 13.65C11.9389 13.8833 11.6667 14 11.3556 14H2.83889ZM11.3556 1.75H2.83889V12.8333H11.3556V1.75Z",
    fill: "#B64545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.199f1fbbec8820e5650d312d7f000978.svg";
export { ForwardRef as ReactComponent };